module.exports = __webpack_public_path__ + "img/table3.6c73b584.png";